const _cloneDeep = require('lodash/cloneDeep');
const _debounce = require('lodash/debounce');

export default {

    safetyClone : _cloneDeep,
    debounce : _debounce,

    uuid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },

    isEmptyNullOrUndefined(string){
        return string === null || string === undefined || string === "";
    },

    isObject(item){
        return typeof item === 'object' && item !== null;
    }

}
